const ferries = {
  ferry: "Balsa", // translated
  ferries: "Balsas", // translated
  selectOriginPort: "Selecione a porta de origem", // translated
  selectDestPort: "Selecione a porta de destino", // translated
  continue: "Continuar", // translated
  viewTimetables: "Ver horários", // translated
  operator: "Operador", // translated
  cabin: "Cabine", // translated
  cabins: "Cabanas", // translated
  place: "Lugar", // translated
  places: "Lugares", // translated
  seat: "Assento", // translated
  seats: "Assentos", // translated
  seating: "Assentos", // translated
  deckSpace: "Espaço no convés", // translated
  compulsory: "obrigatório", // translated
  departure: "Partida", // translated
  total: "Total", // translated
  back: "Voltar", // translated
  next: "Próximo", // translated
  duration: "Duração", // translated
  return: "Retornar", // translated
  prebook: "Pré-reserva", // translated
  travelInfo: "Informações de viagem", // translated
  book: "Livro", // translated
  adults: "Adultos", // translated
  child: "Criança", // translated
  seniors: "Idosos", // translated
  senior: "Senior", // translated
  to: "para", // translated
  passenger: "Passageiro", // translated
  details: "Detalhes", // translated
  currencyForTickets: "A moeda para estes bilhetes será", // translated
  seatsError: "O número de passageiros não é igual à capacidade.", // translated
  title: "Título", // translated
  firstName: "Primeiro nome", // translated
  lastName: "Sobrenome", // translated
  email: "E-mail", // translated
  phone: "Telefone", // translated
  dateOfBirth: "Data de nascimento", // translated
  placeOfBirth: "Local de nascimento", // translated
  groupLeader: "Líder de grupo", // translated
  isRequired: "É necessário", // translated
  charactersOnly: "Somente personagens", // translated
  latinCharactersAndSpacesOnly: "Apenas caracteres latinos e espaços", // translated
  validEmail: "Não é um e-mail válido", // translated
  atLeastOneAdult: "É necessário pelo menos 1 adulto.", // translated
  atLeastOneSenior: "É necessário pelo menos 1 idoso.", // translated
  toastAlert: "Corrija todos os erros nos formulários abaixo.", // translated
  backToFerriesList: "Voltar à lista de ferries", // translated
  bestPrice: "Melhor preço", // translated
  fastest: "O mais rápido", // translated
  beforeDeparture: "Antes da partida", // translated
  perPerson: "por pessoa", // translated
  notAvailableForOnlineBooking: "Não disponível para reserva online", // translated
  hurryLimitedAvailability: "Se apresse! Disponibilidade limitada", // translated
  berth: "Atracar", // translated
  berths: "Berços", // translated
  sumOfSelectionNotEqualToPersons: "A soma da sua seleção não é igual ao número de passageiros", // translated
  attemptToBook: "Você tentou reservar um total de", // translated
  seatsWhenYouHave: "assentos quando você tiver", // translated
  passengersTravelling: "passageiros viajando", // translated
  withReturn: "com passagens de volta", // translated
  pleaseCorrectYourSelection: "Corrija sua seleção", // translated
  pleaseSelectUpTo: "Selecione até", // translated
  accommodationTypes: "tipos de acomodação", // translated
  selectionPrices: "Preços de seleção", // translated
  yourCurrentTicket: "Seu tipo de ingresso atual é", // translated
  upgradeTo: "Atualize para", // translated
  wouldYouLikeToUpgrade: "Gostaria de atualizar seu tipo de ingresso?", // translated
  backToTicketTypes: "Voltar para Tipos de ingresso", // translated
  originPort: "Porto de Origem", // translated
  destinationPort: "Porto de destino", // translated
  outboundDate: "Data de saída", // translated
  inboundDate: "Data de entrada", // translated
  passengers: "Passageiros", // translated
  hasReturn: "Tem Retorno", // translated
  passportNumber: "Número do Passaporte", // translated
  passportExpiryDate: "Data de Expiração do Passaporte", // translated
  passportPlaceOfIssue: "Local de emissão do passaporte", // translated
  passportStartDate: "Data de início do passaporte", // translated
  cityCode: "Código da cidade", // translated
};

export default ferries;
